import { tns } from 'tiny-slider/src/tiny-slider';

export default class TinySliders {
    static init(): void {
        this.reviewSlider();
        this.reviewGallerySlider();
        this.articleCardSlider();
        this.ServiceBoxFiveSlider();
        this.ServiceBoxFourSlider();
        this.ServiceBoxThreeSlider();
        this.SubsidyHelpSliderSlider();
        this.reviewModalSlider();
        this.offersSlider();
        this.offersTwoItemsSlider();
        this.technologyHeaderSlider();
        this.partnerSlider();
        this.headerMobileSlider();
        this.SliderDetail();
        this.InfoCardSlider();
        this.reviewsCarousel();
    }

    static reviewSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-review-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.review-modal-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.review-slider__controls');

                if (sliderContainer && sliderControls) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        gutter: 47,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,

                        responsive: {
                            992: {
                                items: 2,
                                gutter: 30
                            },
                            1441: {
                                items: 3,
                                gutter: 47
                            }
                        },
                    });
                }
            });
        }
    }

    static partnerSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-partner-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.partner-slider__inner');

                if (sliderContainer) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 6,
                        controls: false,
                        nav: false,
                        gutter: 60,
                        edgePadding: 60,
                        loop: true,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        autoplay: true,
                        autoplayTimeout: 2000,
                        autoWidth: true,
                        autoplayButtonOutput: false,
                        center: true,
                        responsive: {
                            1025: {
                                gutter: 120,
                                edgePadding: 120
                            }
                        },
                    });
                }
            });
        }
    }

    static offersSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-offers-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.offers-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.offers-slider__controls');

                if (sliderContainer && sliderControls) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        loop: true,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        navPosition: 'bottom',
                        gutter: 20,

                        responsive: {
                            768: {
                                items: 2,
                            },  
                            1025: {
                                items: 3,
                                nav: true
                            }
                        },
                    });
                }
            });
        }
    }

    static offersTwoItemsSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-offers-two-items-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.offers-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.offers-slider__controls');

                if (sliderContainer && sliderControls) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        loop: true,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        navPosition: 'bottom',
                        gutter: 20,

                        responsive: { 
                            992: {
                                items: 2,
                                nav: true
                            }
                        },
                    });
                }
            });
        }
    }

    static technologyHeaderSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-technology-header-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.technology-header-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.technology-header-slider__controls');

                if (sliderContainer && sliderControls) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        loop: true,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        gutter: 0
                    });
                }
            });
        }
    }

    static headerMobileSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-header-mobile-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.header-mobile-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.header-mobile-slider__controls');

                if (sliderContainer && sliderControls) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        loop: true,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        gutter: 0
                    });
                }
            });

            let maxHeightHeaderItems: number = 0;
            const headerMobileItems: NodeListOf<HTMLElement> = document.querySelectorAll('.header-mobile-slider__text');
    
            if (headerMobileItems.length > 0) {
                headerMobileItems.forEach((item: HTMLElement) => {
                    if (item.offsetHeight > maxHeightHeaderItems) {
                    maxHeightHeaderItems = item.offsetHeight;
                    }
                });
    
                headerMobileItems.forEach((item: HTMLElement) => {
                    item.style.height = `${maxHeightHeaderItems}px`;
                });
            }
        }
    }

    static ServiceBoxFiveSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-service-box-five');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.service-box-slider__inner');

                if (sliderContainer) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controls: false,
                        nav: false,
                        gutter: 27,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        edgePadding: 27,

                        responsive: {
                            768: {
                                items: 3,
                                edgePadding: 0
                            },
                            992: {
                                items: 4,
                            },
                            1200: {
                                disable: true
                            }
                        },
                    });
                }
            });
        }
    }

    static ServiceBoxFourSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-service-box-four');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.service-box-slider__inner');

                if (sliderContainer) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controls: false,
                        nav: false,
                        gutter: 27,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        edgePadding: 27,

                        responsive: {
                            768: {
                                items: 2,
                                edgePadding: 0
                            },
                            991: {
                                items: 3,
                            },
                            1200: {
                                disable: true
                            }
                        },
                    });
                }
            });
        }
    }

    static ServiceBoxThreeSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-service-box-three');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.service-box-slider__inner');

                if (sliderContainer) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controls: false,
                        nav: false,
                        gutter: 27,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        edgePadding: 27,

                        responsive: {
                            768: {
                                items: 2,
                            },
                            992: {
                                disable: true
                            }
                        },
                    });
                }
            });
        }
    }

    static SubsidyHelpSliderSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-subsidy-help__slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.subsidy-help__wrapper');

                if (sliderContainer) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controls: false,
                        nav: false,
                        gutter: 0,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        edgePadding: 0,

                        responsive: {
                            576: {
                                // items: 1,
                                // edgePadding: 0,
                                disable: true
                            },
                            // 992: {
                            //     items: 2,
                            // },
                            // 1200: {
                            // }
                        },
                    });
                }
            });
        }
    }

    static articleCardSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-article-card');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.article-card-slider__inner');

                if (sliderContainer) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controls: false,
                        nav: false,
                        gutter: 10,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,

                        responsive: {
                            768: {
                                items: 2
                            },
                            992: {
                                items: 3,
                            }
                        },
                    });
                }
            });
        }
    }

    static reviewGallerySlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-reference-box-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderWrapper = item.querySelector<HTMLElement>('.reference-box-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.reference-box-slider__controls');

                if (sliderWrapper && sliderControls) {
                    const slider = tns({
                        container: sliderWrapper,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        gutter: 0,
                        loop: false,
                        mouseDrag: false,
                        touch: false,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                    });
                }
            });
        }
    }

    static reviewModalSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-review-modal-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderWrapper = item.querySelector<HTMLElement>('.review-modal-slider__inner');
                const sliderControls = item.querySelector<HTMLElement>('.review-modal-slider__controls');

                if (sliderWrapper && sliderControls) {
                    const slider = tns({
                        container: sliderWrapper,
                        items: 1,
                        controlsContainer: sliderControls,
                        nav: false,
                        gutter: 0,
                        loop: false,
                        mouseDrag: false,
                        touch: false,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        responsive: {
                            992: {
                                mouseDrag: true,
                            }
                        },
                    });
                }
            });
        }
    }

    static SliderDetail(): void {
        const carousels = document.querySelectorAll<HTMLElement>('.js-slider-detail');

        if (carousels.length > 0) {
            carousels.forEach((item) => {

                const sliderDetailContainer = item.querySelector<HTMLElement>('.slider-detail__inner');
                const sliderDetailNav = item.querySelector<HTMLElement>('.slider-detail__nav');
                const sliderDetailControls = item.querySelector<HTMLElement>('.slider-detail__controls');

                if (sliderDetailContainer && sliderDetailNav && sliderDetailControls) {
                    const slider = tns({
                        container: sliderDetailContainer,
                        items: 1,
                        controls: true,
                        controlsContainer: sliderDetailControls,
                        nav: true,
                        navContainer: sliderDetailNav,
                        gutter: 0,
                        loop: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        mouseDrag: false,
                        mode: "gallery",
                        responsive: {
                            992: {
                                mouseDrag: true,
                            }
                        },
                    });
                }
            });
        }
    }

    static InfoCardSlider(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-info-card-slider');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderContainer = item.querySelector<HTMLElement>('.info-card-slider__inner');

                if (sliderContainer) {
                    const slider = tns({
                        container: sliderContainer,
                        items: 1,
                        controls: false,
                        nav: false,
                        gutter: 27,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        edgePadding: 27,

                        responsive: {
                            768: {
                                items: 2,
                                edgePadding: 0
                            },
                            991: {
                                items: 3,
                            },
                            1200: {
                                disable: true
                            }
                        },
                    });
                }
            });
        }
    }

    static reviewsCarousel(): void {
        const carousel = document.querySelectorAll<HTMLElement>('.js-reviews-carousel');
        if (carousel.length > 0) {
            carousel.forEach((item) => {
                const sliderWrapper = item.querySelector<HTMLElement>('.reviews-carousel__items');
                const sliderControls = item.querySelector<HTMLElement>('.reviews-carousel__controls');

                if (sliderWrapper && sliderControls) {
                    const slider = tns({
                        container: sliderWrapper,
                        items: 1.15,
                        controlsContainer: sliderControls,
                        nav: false,
                        gutter: 30,
                        loop: false,
                        mouseDrag: true,
                        preventScrollOnTouch: 'auto',
                        swipeAngle: 30,
                        responsive: {
                            768: {
                                items: 2,
                                slideBy: 2,
                            },
                            1081: {
                                items: 3,
                                gutter: 100,
                                slideBy: 3,
                                mouseDrag: true
                            }
                        },
                    });
                }
            });
        }
    }
}
